import React, { useState } from 'react';
import { CompanyOverview } from './CompanyOverview';
import { ManagementView } from './ManagementView';
import { Reports } from './Reports';
import { TabContainer, Tab } from '../../ui';
import type { CompanyState } from '@/types/company';
import type { Product, Employee, HiringProcess } from '@/types/tycoon';

interface CompanyViewProps {
  companyState: CompanyState;
  products: Product[];
  employees: Employee[];
  hiringProcesses: HiringProcess[];
}

export const CompanyView: React.FC<CompanyViewProps> = ({
  companyState,
  products,
  employees,
  hiringProcesses
}) => {
  const [activeSubtab, setActiveSubtab] = useState('overview');

  const tabs: Tab[] = [
    { id: 'overview', label: 'Overview' },
    { id: 'management', label: 'Management' },
    { id: 'reports', label: 'Reports' },
  ];

  return (
    <TabContainer tabs={tabs} activeTab={activeSubtab} onTabChange={setActiveSubtab}>
      {activeSubtab === 'reports' && (
        <Reports
          products={products}
          companyState={companyState}
          employees={employees}
        />
      )}
      {activeSubtab === 'overview' && (
        <CompanyOverview
          companyState={companyState}
          products={products}
          employees={employees}
        />
      )}
      {activeSubtab === 'management' && (
        <ManagementView
          companyState={companyState}
          employees={employees}
          hiringProcesses={hiringProcesses}
        />
      )}
    </TabContainer>
  );
};
